var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState, useRef } from 'react';
import '@cb/apricot/CBPagination';
import '@cb/apricot/CBIcon';
import { useUID } from 'react-uid';
import PageButton from './PageButton';
// prev & next buttons
const previousIcon = React.createElement("span", { "aria-hidden": "true", className: "cb-icon cb-left" });
const nextIcon = React.createElement("span", { "aria-hidden": "true", className: "cb-icon cb-right" });
const paginationBtnCount = (node) => {
    // base on apricots button size
    const btnWidth = 48;
    const maxWidth = node ? node.offsetWidth : 0;
    // we always have next and prev
    return Math.floor(maxWidth / btnWidth) - 2;
};
const getPaginationRange = (current, m, delta) => {
    const last = m;
    const left = current - delta;
    const right = current + delta + 1;
    const range = [];
    const rangeWithDots = [];
    let l;
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i <= last; i++) {
        if (i === 1 || i === last || (i >= left && i < right)) {
            range.push(i);
        }
    }
    range.forEach(i => {
        if (l) {
            if (i - l === 2) {
                rangeWithDots.push(l + 1);
            }
            else if (i - l !== 1) {
                rangeWithDots.push('...');
            }
        }
        rangeWithDots.push(i);
        l = i;
    });
    return rangeWithDots;
};
const pagination = (current, m, delta, responsive, node) => {
    const rangeWithDots = getPaginationRange(current, m, delta);
    const count = rangeWithDots.length;
    const maxBtnNum = paginationBtnCount(node);
    if (responsive) {
        if (count > maxBtnNum && delta >= 0) {
            return pagination(current, m, delta - 1, responsive, node);
        }
        return rangeWithDots;
    }
    return rangeWithDots;
};
export const Pager = (_a) => {
    var { pagerId, buttonId, responsive = true, current, max, delta = 3, disabled = [], ariaLabel = 'pagination', onPageChange } = _a, props = __rest(_a, ["pagerId", "buttonId", "responsive", "current", "max", "delta", "disabled", "ariaLabel", "onPageChange"]);
    const uid = useUID();
    // eslint-disable-next-line no-param-reassign
    pagerId = pagerId || `apricot_pager_${uid}`;
    const pagerRef = useRef(null);
    const [pageData, setPageData] = useState([]);
    const resizeEvent = (node) => {
        const event = new CustomEvent(`apricot_pagerChange_${pagerId}`);
        window.addEventListener('resize', () => {
            const currentBtnNum = node.querySelectorAll('li').length;
            const maxBtnNum = paginationBtnCount(node);
            if (maxBtnNum !== currentBtnNum) {
                document.dispatchEvent(event);
            }
        });
    };
    const setPaginationData = () => {
        const node = pagerRef.current;
        setPageData(pagination(current, max, delta, responsive, node));
    };
    const onClick = (page, e) => {
        e.preventDefault();
        onPageChange && onPageChange(page);
    };
    useEffect(() => {
        setPaginationData();
        if (responsive) {
            resizeEvent(pagerRef.current);
            document.addEventListener(`apricot_pagerChange_${pagerId}`, setPaginationData);
        }
        // kill custom event
        return () => {
            if (responsive) {
                document.removeEventListener(`apricot_pagerChange_${pagerId}`, setPaginationData);
            }
        };
    }, [delta, current, max, responsive]);
    return (React.createElement("nav", Object.assign({ "aria-label": ariaLabel, "data-cbtrack-comp": "apricot-react:pager", ref: pagerRef, id: pagerId }, props),
        React.createElement("ul", { className: "cb-pagination" },
            React.createElement(PageButton, { buttonId: `${buttonId}_prev`, key: "prev", disabled: current === 1, srDescription: "Go to previous page", onClick: e => onClick(current - 1, e) }, previousIcon),
            pageData.map((page, index) => page === '...' ? (React.createElement(PageButton, { buttonId: `${buttonId}_${index}`, key: `more-${index}`, srDescription: "More Pages", disabled: true }, "...")) : (React.createElement(PageButton, { buttonId: `${buttonId}_${index}`, key: `page-${page}`, disabled: disabled.includes(parseInt(page, 10)), active: page === current, srDescription: "Go to page ", onClick: e => onClick(page, e) }, page))),
            React.createElement(PageButton, { buttonId: `${buttonId}_next`, key: "next", disabled: current === max, srDescription: "Go to next page", onClick: e => onClick(current + 1, e) }, nextIcon))));
};
//# sourceMappingURL=Pager.js.map